import { get } from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import type { ColumnCss, ColumnDefinition } from './Column'
import type { SingleLayoutData } from '@wix/thunderbolt-becky-types'

const getColumnRatioFromLayout = (singleLayoutData: SingleLayoutData): number => {
	const columnRatio = get(singleLayoutData, ['containerLayout', 'contentArea', 'ratio']) ?? 1

	return columnRatio * 100
}

export const css = withCompInfo<ColumnCss, ColumnDefinition>()(
	[
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compLayout',
		'compSingleLayout',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		'isOneDocMigrated',
	],
	({
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compLayout,
		compSingleLayout,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		isOneDocMigrated,
	}) => {
		const backgroundMedia = compDesign?.background || {}

		const fillLayersCSSVars = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		const layoutCss = isOneDocMigrated
			? {
				'--column-flex': getColumnRatioFromLayout(compSingleLayout!),
			}
			: {
				width: '100%',
				'--column-width': `${compLayout.width}px`,
				'--column-flex': compLayout.width,
			}

		return {
			...fillLayersCSSVars,
			...layoutCss,
		}
	}
)
